import { DomainError } from '../errors/domain-error';

export const GROWTH_SPONSORSHIP_OFFER_MAX = 30;
export const GROWTH_SPONSORSHIP_ADVERTISER_MAX = 80;
export const GROWTH_SPONSORSHIP_HEADLINE_MAX = 120;
export const GROWTH_SPONSORSHIP_BODY_MAX = 500;
export const GROWTH_SPONSORSHIP_CTA_LABEL_MAX = 60;
export const GROWTH_SPONSORSHIP_DISCLOSURE_MAX = 160;
export const GROWTH_SPONSORSHIP_AFFILIATE_CODE_MAX = 64;

export type GrowthSponsorshipSlot = 'primary' | 'secondary';

export function assertGrowthSponsorshipOfferLimit(count: number) {
  if (count >= GROWTH_SPONSORSHIP_OFFER_MAX) {
    throw new DomainError(`You can save at most ${GROWTH_SPONSORSHIP_OFFER_MAX} sponsorship offers`);
  }
}

export function normalizeGrowthAffiliateCode(value?: string | null): string | null {
  const code = value?.trim().slice(0, GROWTH_SPONSORSHIP_AFFILIATE_CODE_MAX) ?? '';
  if (!code) return null;
  if (!/^[a-zA-Z0-9_-]+$/.test(code)) {
    throw new DomainError('Affiliate code may only contain letters, numbers, underscores, and hyphens');
  }
  return code;
}
